import script from "./Description.vue?vue&type=script&setup=true&lang=js"
export * from "./Description.vue?vue&type=script&setup=true&lang=js"

import "./Description.vue?vue&type=style&index=0&id=5b169942&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b169942"]])

export default __exports__